// extracted by mini-css-extract-plugin
module.exports = {"loading-content":"loading-content","lds-ellipsis":"lds-ellipsis"};